import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Kiacarenceonrentinmumbai() {



const cardData = {
  keyword: " Kia Carens On Rent in Mumbai",

headingDescription:
  "Omshree Cab provides reliable and comfortable Kia Carens on rent in Mumbai for travelers seeking a spacious, feature-rich, and family‑friendly ride for city travel, airport transfers, group trips, outstation travel, or leisure outings. The Kia Carens is a modern multi‑purpose vehicle (MPV) known for its flexible seating arrangements, smooth performance, generous legroom, and advanced comfort features, making it ideal for families, friends, and corporate travel. We offer flexible rental options including one‑way bookings, round trips, hourly packages, and full‑day rentals with transparent pricing and no hidden charges. All Kia Carens vehicles in our fleet are air‑conditioned, regularly serviced, and driven by professional chauffeurs familiar with Mumbai’s routes and traffic. With easy online booking, punctual pickups from any location in Mumbai (including airport, railway station, hotels, and residences), and 24/7 customer support, renting a Kia Carens in Mumbai becomes seamless and stress‑free.",

topPlaces: [
  {
    title: "Gateway of India",
    description:
      "Gateway of India is one of the most iconic landmarks in Mumbai located on the waterfront in South Mumbai. Built during the British era, this historic arch monument attracts visitors for sightseeing, photography, and boat rides to Elephanta Island. The surrounding Colaba area also features cafes, heritage buildings, and street markets that draw tourists throughout the day. Renting a Kia Carens in Mumbai makes it convenient for families or groups to reach this famous destination comfortably, start their sightseeing, and enjoy the city without transport hassles."
  },
  {
    title: "Marine Drive",
    description:
      "Marine Drive is a scenic coastal road along the Arabian Sea, popularly known as the Queen’s Necklace because of the lights that glimmer at night. Visitors come here for sunset views, evening walks, and relaxing drives along this iconic boulevard. The long stretch connects several major attractions in South Mumbai. Renting a Kia Carens makes it easy to enjoy a smooth and comfortable ride while exploring Marine Drive and nearby spots at your own pace."
  },
  {
    title: "Juhu Beach",
    description:
      "Juhu Beach is one of Mumbai’s most popular seaside spots known for its sandy shores, lively atmosphere, and delicious street food such as pav bhaji, bhel puri, and pani puri. Families and tourists often visit to enjoy the sea breeze, sunset views, and casual outings with friends. Hiring a Kia Carens provides ample seating and luggage space, making it ideal for family outings to Juhu Beach and nearby attractions."
  },
  {
    title: "Siddhivinayak Temple",
    description:
      "Siddhivinayak Temple is a revered Hindu temple in Mumbai dedicated to Lord Ganesha. Devotees and tourists visit throughout the year to seek blessings, participate in rituals, and experience the spiritual ambiance. Located centrally in the city, traveling here during festivals can be busy. Renting a Kia Carens offers comfortable and stress‑free transport, especially for families or groups, avoiding the hassle of public transport and parking."
  },
  {
    title: "Bandra Worli Sea Link",
    description:
      "Bandra Worli Sea Link is an impressive cable‑stayed bridge connecting Bandra and Worli across the Arabian Sea. The bridge offers breathtaking views of the sea and city skyline, especially at sunset or in the evening when it is illuminated. Many travelers choose this iconic route for scenic drives. A Kia Carens rental makes it comfortable for groups to enjoy this drive without worrying about navigation or traffic."
  },
  {
    title: "Haji Ali Dargah",
    description:
      "Haji Ali Dargah is a famous mosque and shrine located on a small island off the coast of Mumbai. The white marble structure rises from the sea and is connected to the mainland by a narrow walkway visible during low tide. Pilgrims and visitors come for prayers, sightseeing, and to enjoy the peaceful sea views. Renting a Kia Carens allows travelers to reach this spiritual destination comfortably without the stress of navigating crowded roads."
  },
  {
    title: "Elephanta Caves",
    description:
      "Elephanta Caves are a complex of ancient rock‑cut temples located on Elephanta Island in Mumbai Harbour. Known for their magnificent stone carvings dedicated to Lord Shiva, the caves are a UNESCO World Heritage Site and attract history enthusiasts and tourists alike. Visitors typically take a ferry from the Gateway of India to reach the island. Renting a Kia Carens ensures a hassle‑free ride to the ferry terminal, making it easier to enjoy this cultural excursion."
  },
  {
    title: "Sanjay Gandhi National Park",
    description:
      "Sanjay Gandhi National Park is a large protected forest reserve within Mumbai offering trekking trails, nature walks, wildlife viewing, and the ancient Kanheri Caves. Nature lovers and families enjoy the outdoor activities and scenic trails. Renting a Kia Carens provides a comfortable and spacious ride for a day trip to this natural retreat, especially when traveling with family or groups."
  },
  {
    title: "Colaba Causeway",
    description:
      "Colaba Causeway is a lively shopping street in South Mumbai featuring markets, boutiques, cafes, and local eateries. Visitors enjoy browsing clothes, accessories, souvenirs, and crafts while experiencing the vibrant local culture. A Kia Carens rental allows tourists to reach this popular market area comfortably and continue exploring other nearby attractions."
  },
  {
    title: "Hanging Gardens",
    description:
      "Hanging Gardens, also known as Pherozeshah Mehta Gardens, are landscaped terraces on Malabar Hill offering panoramic views of Marine Drive and the Arabian Sea. Visitors come here for morning walks, photography, and relaxation amidst serene greenery. Renting a Kia Carens makes it easy to visit this scenic spot with family or groups and include it in a full day of memorable sightseeing in Mumbai."
  }
],



services: [
{
name: "Kia Carens on Rent Mumbai",
description: "Kia Carens on rent Mumbai service offers premium and comfortable transportation for families, corporate travelers, and tourist groups traveling within the city or to outstation destinations. The Kia Carens is a modern MPV known for spacious interiors, stylish design, and smooth highway performance. Our vehicles are well maintained and suitable for long-distance travel with comfortable seating and luggage space. Professional drivers ensure safe driving and punctual pickup services from homes, hotels, offices, railway stations, and Mumbai airport terminals. Air-conditioned interiors ensure relaxed travel during long journeys. Ideal for airport transfers, family trips, and business travel."
},
{
name: "Kia Carens Taxi Mumbai",
description: "Kia Carens taxi Mumbai service provides reliable and comfortable travel options across Mumbai city and nearby destinations. The Kia Carens offers spacious seating and modern interiors suitable for both city rides and long-distance journeys. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Air-conditioned vehicles ensure comfortable travel for families and small groups. Ideal for airport transfers, city tours, and outstation travel."
},
{
name: "Kia Carens Cab Service Mumbai",
description: "Kia Carens cab service Mumbai provides premium MPV transportation for travelers seeking comfort and reliability. The vehicle offers spacious interiors and smooth ride quality suitable for both city travel and highway journeys. Professional drivers ensure punctual pickup services and safe driving across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for family travel, airport transfers, and corporate transportation."
},
{
name: "Kia Carens Rental Mumbai",
description: "Kia Carens rental Mumbai offers comfortable vehicle hire options for passengers needing modern MPV transportation. The Kia Carens provides spacious seating and smooth ride quality suitable for family trips, corporate travel, and tourism journeys. Vehicles are well maintained and suitable for both city rides and interstate travel. Professional drivers ensure safe driving and punctual pickup services across Mumbai."
},
{
name: "Kia Carens Airport Cab Mumbai",
description: "Kia Carens airport cab Mumbai service provides reliable airport pickup and drop transportation for passengers traveling to or from Mumbai International Airport. The spacious MPV provides comfortable seating and luggage capacity suitable for airport transfers. Professional drivers ensure punctual pickups according to flight schedules. Pickup services are available from homes, hotels, offices, and railway stations across Mumbai."
},
{
name: "Kia Carens Outstation Cab Mumbai",
description: "Kia Carens outstation cab Mumbai service offers comfortable long-distance travel from Mumbai to destinations across Maharashtra and India. The MPV provides spacious seating and smooth highway performance suitable for extended road journeys. Professional drivers ensure safe interstate travel and punctual pickup services across Mumbai. Ideal for family vacations, pilgrimage tours, and tourism travel."
},
{
name: "Kia Carens One Way Cab Mumbai",
description: "Kia Carens one way cab Mumbai service provides economical travel options for passengers needing transportation without return charges. This service helps reduce travel costs while enjoying premium MPV comfort. Vehicles provide spacious seating and smooth ride quality suitable for long-distance journeys. Professional drivers ensure safe driving and punctual pickup services across Mumbai."
},
{
name: "Kia Carens Round Trip Taxi Mumbai",
description: "Kia Carens round trip taxi Mumbai service provides convenient transportation for passengers planning return journeys after visiting their destination. The vehicle remains available as per travel plans ensuring comfortable travel for both directions. Spacious interiors and air-conditioned comfort make long-distance travel relaxed and enjoyable."
},
{
name: "Kia Carens Cab Booking Mumbai",
description: "Kia Carens cab booking Mumbai allows passengers to easily reserve MPV vehicles for city rides, airport transfers, and outstation journeys. Online and phone booking options provide quick confirmation and flexible ride scheduling. Vehicles provide comfortable seating and reliable performance suitable for family and group travel."
},
{
name: "Kia Carens Taxi Booking Online Mumbai",
description: "Kia Carens taxi booking online Mumbai provides quick digital reservations for passengers planning comfortable travel. Travelers can easily schedule rides online and receive instant booking confirmation. Vehicles provide smooth ride quality and spacious seating suitable for city travel and long-distance journeys."
},
{
name: "Kia Carens Cab Price Mumbai",
description: "Kia Carens cab price Mumbai options provide transparent fare estimates depending on travel distance, vehicle availability, and trip duration. Passengers can easily plan their travel budget with clear pricing structures. The MPV provides comfortable seating and premium travel experience suitable for family and group travel."
},
{
name: "Kia Carens Taxi Fare Mumbai",
description: "Kia Carens taxi fare Mumbai services offer flexible pricing depending on vehicle usage, travel distance, and trip duration. Passengers can enjoy comfortable MPV travel with clear fare structures and transparent billing policies."
},
{
name: "Cheap Kia Carens Cab Mumbai",
description: "Cheap Kia Carens cab Mumbai service provides budget-friendly MPV travel options without compromising comfort or safety. Travelers can enjoy spacious seating, air-conditioned interiors, and smooth ride quality at economical pricing. Ideal for family trips and group transportation."
},
{
name: "Best Kia Carens Rental Mumbai",
description: "Best Kia Carens rental Mumbai service provides premium MPV transportation for travelers seeking modern and comfortable travel. The Kia Carens offers stylish interiors, spacious seating, and smooth ride quality suitable for both city rides and outstation journeys."
},
{
name: "Kia Carens Family Cab Mumbai",
description: "Kia Carens family cab Mumbai service provides spacious and comfortable transportation ideal for families traveling together. The MPV seating arrangement allows relaxed travel with sufficient luggage space suitable for vacation trips and family outings."
}
],

tableData: [
["Kia Carens on Rent Mumbai","Kia Carens Taxi Mumbai"],
["Kia Carens Cab Service Mumbai","Kia Carens Rental Mumbai"],
["Kia Carens Airport Cab Mumbai","Kia Carens Outstation Cab Mumbai"],
["Kia Carens One Way Cab Mumbai","Kia Carens Round Trip Taxi Mumbai"],
["Kia Carens Cab Booking Mumbai","Kia Carens Taxi Booking Online Mumbai"],
["Kia Carens Cab Price Mumbai","Kia Carens Taxi Fare Mumbai"],
["Cheap Kia Carens Cab Mumbai","Best Kia Carens Rental Mumbai"],
["Kia Carens Family Cab Mumbai","Luxury Kia Carens Taxi Mumbai"]
],



whychoose: [
  {
    WhyChooseheading: "Spacious 6+1 Seater Comfort",
    WhyChoosedescription: "Kia Carens is a spacious 6+1 seater vehicle perfect for family trips, airport transfers, and corporate travel in Mumbai. The car provides comfortable seating, large luggage space, and modern interiors for a relaxing journey."
  },
  {
    WhyChooseheading: "Transparent Rental Pricing",
    WhyChoosedescription: "Omshree Cabs offers transparent pricing for Kia Carens on rent in Mumbai. Customers receive complete details about per-kilometer rates, toll charges, and driver allowance before confirming the booking."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Our Kia Carens rental service in Mumbai operates 24 hours a day. Whether you need a late-night airport transfer or an early morning pickup, our cabs are available anytime."
  },
  {
    WhyChooseheading: "Clean & Well Maintained Vehicles",
    WhyChoosedescription: "All Kia Carens vehicles are regularly serviced, cleaned, and sanitized to provide a safe and comfortable travel experience for passengers."
  },
  {
    WhyChooseheading: "Flexible Local & Outstation Packages",
    WhyChoosedescription: "We offer flexible travel packages including local Mumbai sightseeing, airport transfers, one-way trips, and outstation travel to destinations like Pune, Lonavala, Nashik, Shirdi, and Gujarat."
  },
  {
    WhyChooseheading: "Perfect for Family & Corporate Travel",
    WhyChoosedescription: "The Kia Carens is ideal for family trips, corporate travel, and small group tours thanks to its spacious seating, modern features, and smooth ride quality."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Mumbai",
    WhyChoosedescription: "Omshree Cabs provides convenient pickup from homes, offices, hotels, railway stations, and airports anywhere in Mumbai so your journey starts comfortably."
  },
  {
    WhyChooseheading: "Trusted Cab Service in Mumbai",
    WhyChoosedescription: "Omshree Cabs is trusted by many travelers for Kia Carens rental in Mumbai thanks to our punctual drivers, comfortable vehicles, and professional customer service."
  }
]
};

const faqData = [
  { question: "Do you provide Kia Carens on rent in Mumbai?", answer: "Yes, Omshree Cabs provides Kia Carens rental services in Mumbai for local travel, airport transfers, and outstation trips." },
  { question: "What is the seating capacity of the Kia Carens?", answer: "The Kia Carens is a 6+1 seater vehicle, making it ideal for family travel and small group trips." },
  { question: "What is the rental price for Kia Carens in Mumbai?", answer: "Kia Carens rental typically starts around ₹16 per km for outstation travel and local packages may vary depending on travel duration and distance." },
  { question: "Can I book Kia Carens for outstation trips?", answer: "Yes, Kia Carens is commonly used for outstation trips from Mumbai to destinations like Pune, Mahabaleshwar, Shirdi, and Gujarat." },
  { question: "Do you provide airport pickup with Kia Carens?", answer: "Yes, Omshree Cabs provides Kia Carens airport pickup and drop services at Mumbai Airport." },
  { question: "Are Kia Carens vehicles air-conditioned?", answer: "Yes, all Kia Carens vehicles provided by Omshree Cabs are fully air-conditioned for comfortable travel." },
  { question: "Is Kia Carens suitable for corporate travel?", answer: "Yes, Kia Carens is widely used for corporate travel because of its spacious seating and modern interior features." },
  { question: "Do you provide driver with Kia Carens rental?", answer: "Yes, all Kia Carens rentals include a professional driver for safe and comfortable travel." },
  { question: "Can Kia Carens be used for family trips?", answer: "Yes, Kia Carens is ideal for family travel because it offers comfortable seating and ample luggage space." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohan Mehta",
    feedback:
      "We booked a Kia Carens from Omshree Cabs for our Mumbai to Lonavala family trip. The vehicle was spacious and the ride was very comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Shilpa Shah",
    feedback:
      "Excellent Kia Carens rental service in Mumbai. Clean car, punctual driver, and smooth travel made our journey very enjoyable.",
    rating: 5
  }
];









































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Kia Carens On Rent in Mumbai",
  "description": "Rent a Kia Carens in Mumbai with Omshree Cab for airport transfers, outstation trips, one-way or round-trip journeys. Enjoy a comfortable, spacious, and stylish ride ideal for families, corporate travel, and group trips with flexible booking options and transparent pricing.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "720"
  }
};






  return (
    <div>
      
<Helmet>
  <title>Kia Carens On Rent Mumbai | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Book Kia Carens on rent in Mumbai with Omshree Cab for airport transfers, outstation trips, one-way or round trips. Comfortable, spacious, and reliable Kia Carens cab service for families and corporate travel." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/80.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Kiacarenceonrentinmumbai;